// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mLcA","colMin":"styles_colMin__3FqBY"};